<template>
    <b-form-select :id="tag"
            :name="tag"
            v-model="value"
            :state="null"
            @change="onChange"
            @keyup.native.esc="onKeyEsc"
            @keyup.native.enter="onKeyEnter"
            @keydown.native.arrow-left="onKeyArrows"
            @keydown.native.arrow-right="onKeyArrows"
            :disabled="disabled && ! isDataEventDeleted || committed"
            size="sm"
            v-bind:class="{itempropertyupdated: isUpdated && ! isDataEventDeleted}"
            :style="'min-width: ' + getCellWidth(tag) + 'em;'"
    >
        <option v-for="option in options" :key="option.id" :value="option.id" :selected="option.selected" :disabled="option.disabled">{{ option.value }}</option>
    </b-form-select>
</template>

<script>
    import baseGridMixin from './BaseGridMixin.vue'
    import cellTypeMixin from './CellTypeMixin.vue'
    export default {
        mixins: [baseGridMixin, cellTypeMixin],
        props: {
            tag: {
                type: String,
                required: true
            },
            options: {
                type: Array|Object,
                required: true
            },
            validation: {
                type: Object
            },
            brandId: {
                type: Number|String,
                required: true
            },
            countryId: {
                type: String,
                required: true
            },
            route: {
                type: String,
                required: true
            },
            storedData: {
                type: String|Number,
                default: null
            },
            placeholder: String,
            disabled: {
                type: Boolean,
                default: false
            },
            committed: {
                type: Boolean,
                default: false
            },
            gridItemIndex: {
                type: Number,
                required: true
            }
        },

        data () {
            let data;

            if (this.storedData.is_updated) {
                data = this.storedData.updated;
            } else {
                data = this.storedData.original;
            }

            return {
                value: data,
                isUpdated: this.storedData.is_updated,
            }
        },

        computed: {
            isDataEventDeleted: function() {
                return this.isDatastatusSelect && this.value === 'D';
            },
        },

        methods: {
            onKeyArrows: function (event) {
                event.preventDefault();
            },
            onKeyEsc: function (event) {
                this.isUpdated = false;
                this.storedData.is_updated = false;
                this.storedData.updated = "";
                this.value = this.storedData.original;
                this.onChange(this.value);
            },
            onKeyEnter: function (event) {
                this.focusNextCell();
            },
            onChange: function (event) {
                let cellStateUnchanged = this.determineCellState();

                this.postUpdate(event, cellStateUnchanged);
            },
            determineCellState: function () {
                let cellStateUnchanged = false;
                if (this.value == this.storedData.original) {
                    this.isUpdated = false;
                    cellStateUnchanged = true;
                } else {
                    this.isUpdated = true;
                }
                this.$emit('dataUpdated');

                let cellKey = this.tag.substring(0, this.tag.lastIndexOf('__'));

                if (this.isDatastatusSelect(cellKey)) {
                    this.$emit('rowDeleteStateChanged', this.tag, this.value);
                }

                if (this.isOptionalExtraSelect(cellKey)) {
                    this.$emit('optionalExtraSelect', this.tag, this.value);
                }

                return cellStateUnchanged;
            },
            isCellUpdated: function () {
                return this.isUpdated;
            },
            getCellWidth: function (tag) {
                let contentLength = 1;
                let minWidth = 2;
                let factor = 0.7;
                let itemTag = tag.split('__');
                itemTag = itemTag[0] + '__' + itemTag[1];
                /** Get the cell width preference from CellTypeMixin */
                let widthMap = this.cellWidthMap;
                if (itemTag) {
                    if (widthMap.hasOwnProperty(itemTag)) {
                        minWidth = widthMap[itemTag];
                    }
                }
                /** Calculate the cell width based on its content */
                let choice = this.options.find(element => element.id === this.value)
                if (choice) {
                    let content = choice.value;
                    contentLength = content.toString().length;
                }
                if (contentLength * factor > minWidth) {
                    minWidth = contentLength * factor;
                }
                return minWidth;
            },
            getCellTextAlign: function (tag) {
                let itemTag = tag.split('__');
                itemTag = itemTag[0] + '__' + itemTag[1];
                let alignment = 'left';
                let alignmentMap = {
                    'prices__data_event': 'center',
                    "prices__model_year": 'center',
                    "versions__limited_edition": 'center',
                    "core_specs__gearbox_no_of_gears": 'center',
                    "core_specs__emission_class": 'center',
                    'prices__import_method': 'center'
                }
                if (itemTag) {
                    if (alignmentMap.hasOwnProperty(itemTag)) {
                        alignment = alignmentMap[itemTag];
                    }
                }
                return alignment;
            }
        },
    }
</script>
